import React from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import TableDragDivider from "@FillInTableContainer/shared/components/TableDragDivider/TableDragDivider";
import { useHandleTableCreatorSubGroupShellDrag } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorSubGroupShellDrag";
import { TableCreatorSubGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealLaScKeyCommentListSubGroupShell from "./components/DealLaScKeyCommentListSubGroupShell/DealLaScKeyCommentListSubGroupShell";
import * as S from "./DealLaScKeyCommentListCreatorGroupShell.style";
import useCheckIsDisplaySubGroupShellDragDivider from "../../../../../DealLaScDealTermsGroupTable/components/DealLaScRightsScopeGroupTable/components/DealLaScRightsScopeTable/components/DealLaScRightsScopeGroupShellSection/components/DealLaScRightsScopeGroupShell/hooks/useCheckIsDisplaySubGroupShellDragDivider";
import { useGetNumberOfSupGroupShell } from "../../../../../DealLaScDealTermsGroupTable/components/DealLaScRightsScopeGroupTable/components/DealLaScRightsScopeTable/components/DealLaScRightsScopeGroupShellSection/components/DealLaScRightsScopeGroupShell/hooks/useGetNumberOfSubGroupShell";

const ARTICLE_SECTION = ENTRY_DATA_SECTION_KEYS.dealsLaSc;

interface Props {
  groupTableKey: DealLaScSection;
  groupTableIndex: number;
  groupShellKey: string | null;
  groupShellIndex: number;
  subGroupShellList: TableCreatorSubGroupShellList;
  tableKey: string | null;
  tableIndex: number;
}

const DealLaScKeyCommentListCreatorGroupShell = ({
  groupTableKey,
  groupTableIndex,
  groupShellKey,
  groupShellIndex,
  subGroupShellList,
  tableKey,
  tableIndex,
}: Props) => {
  const { subGroupShellCount } = useGetNumberOfSupGroupShell(ARTICLE_SECTION);

  const {
    handleSubGroupShellDragEnd,
    handleSubGroupShellDragOn,
    handleSubGroupShellDragOver,
    handleSubGroupShellDragStart,
    subGroupShellDraggedIndexInfo,
    isDraggingSubGroupShell,
  } = useHandleTableCreatorSubGroupShellDrag(ARTICLE_SECTION, tableIndex);

  const { isLastSubGroupShell, handleCheckDragDividerDisplay } =
    useCheckIsDisplaySubGroupShellDragDivider({
      tableIndex,
      groupShellIndex,
      isDraggingSubGroupShell,
    });

  return (
    <S.GroupShell>
      {subGroupShellList.map(({ subGroupShellKey, shellList }) =>
        newArrayToCountValue(
          subGroupShellCount(subGroupShellKey, tableIndex, groupShellIndex),
        ).map((_, subGroupShellIndex) => (
          <S.DraggableSubGroupShellWrapper
            key={`subGroupShell-${String(groupTableIndex)}-${String(
              tableIndex,
            )}-${String(subGroupShellIndex)}`}
            isTargetDraggingTable={
              isDraggingSubGroupShell &&
              subGroupShellDraggedIndexInfo[0] !== subGroupShellIndex
            }
            onDragOver={(event) =>
              handleSubGroupShellDragOver(event, subGroupShellIndex)
            }
          >
            <TableDragDivider
              isDraggingEndPosition={handleCheckDragDividerDisplay({
                moveDragIndex: subGroupShellDraggedIndexInfo[1],
                startDragIndex: subGroupShellDraggedIndexInfo[0],
                subGroupShellIndex,
                subGroupShellKey,
              })}
            />
            <DealLaScKeyCommentListSubGroupShell
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              groupShellKey={groupShellKey}
              groupShellIndex={groupShellIndex}
              subGroupShellKey={subGroupShellKey}
              subGroupShellIndex={subGroupShellIndex}
              subGroupShellCount={subGroupShellCount(
                subGroupShellKey,
                tableIndex,
                groupShellIndex,
              )}
              shellList={shellList}
              tableKey={tableKey}
              tableIndex={tableIndex}
              handleDragStart={handleSubGroupShellDragStart}
              handleDragEnd={handleSubGroupShellDragEnd}
              handleDragOn={handleSubGroupShellDragOn}
            />
            {isLastSubGroupShell(subGroupShellIndex, subGroupShellKey) && (
              <TableDragDivider
                isDraggingEndPosition={handleCheckDragDividerDisplay({
                  moveDragIndex: subGroupShellDraggedIndexInfo[1],
                  startDragIndex: subGroupShellDraggedIndexInfo[0],
                  subGroupShellIndex,
                  subGroupShellKey,
                  lastIndex: newArrayToCountValue(
                    subGroupShellCount(
                      subGroupShellKey,
                      tableIndex,
                      groupShellIndex,
                    ),
                  ).length,
                })}
              />
            )}
          </S.DraggableSubGroupShellWrapper>
        )),
      )}
    </S.GroupShell>
  );
};

export default DealLaScKeyCommentListCreatorGroupShell;
